import React, {useEffect, useState} from "react";
import { useDrop } from 'react-dnd';
import DraggableItem from "./DraggableItem";
import {AnimatePresence} from "framer-motion";
import classes from './DraggingWrappers.module.css'



export default function DroppableList({ list, setList, targetListName, moveItemBetweenLists, itemType = 'DRAGGABLE_ITEM', sameItem, setDragging}) {
    const [stateList, setStateList] = useState([])

    useEffect(() => {
        if (!moveItemBetweenLists) {
            setStateList(list)
        }
    }, [list, moveItemBetweenLists]);

    const [, drop] = useDrop({
        accept: itemType,
        drop: (draggedItem) => {
            // the else case would be reordering. Maybe do later...
            if (draggedItem.sourceList !== targetListName) {
                if (moveItemBetweenLists) {
                    moveItemBetweenLists(draggedItem.item, draggedItem.sourceList, targetListName);
                } else {
                    if (!stateList.some(i => sameItem(i,draggedItem.item))) {
                        setList(draggedItem.item)
                        setStateList(prev => [draggedItem.item, ...prev])
                    }
                }
            }
        },
    });

    const listStyle = {
        minHeight: list.length > 0 || stateList.length > 0 ? 0 : '40px',

    }

    return (
        <div
            ref={drop}
            className={classes.DefaultDroppableList}
            style={listStyle}
        >
            <AnimatePresence initial={false}>
                {!moveItemBetweenLists ?
                    stateList.map((item, index) => (
                            <DraggableItem
                                key={item.id} // Use id for key
                                item={item}
                                itemType={itemType}
                                index={index}
                                sourceList={targetListName}
                                onDragStart={() => setDragging && setDragging(true)}
                                onDragEnd={() => setDragging && setDragging(false)}
                                noStyle
                            />
                        ))
                    :
                    list.map((item, index) => (
                            <DraggableItem
                                key={item.id} // Use id for key
                                item={item}
                                itemType={itemType}
                                index={index}
                                sourceList={targetListName}
                                onDragStart={() => setDragging && setDragging(true)}
                                onDragEnd={() => setDragging && setDragging(false)}
                                noStyle
                            />
                        ))

                }
            </AnimatePresence>
        </div>
    );
};